webpackJsonp([35783957827783],{

/***/ 385:
/***/ (function(module, exports) {

	/**
	 * Code refactored from Mozilla Developer Network:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 */
	
	'use strict';
	
	function assign(target, firstSource) {
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert first argument to object');
	  }
	
	  var to = Object(target);
	  for (var i = 1; i < arguments.length; i++) {
	    var nextSource = arguments[i];
	    if (nextSource === undefined || nextSource === null) {
	      continue;
	    }
	
	    var keysArray = Object.keys(Object(nextSource));
	    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	      var nextKey = keysArray[nextIndex];
	      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	      if (desc !== undefined && desc.enumerable) {
	        to[nextKey] = nextSource[nextKey];
	      }
	    }
	  }
	  return to;
	}
	
	function polyfill() {
	  if (!Object.assign) {
	    Object.defineProperty(Object, 'assign', {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: assign
	    });
	  }
	}
	
	module.exports = {
	  assign: assign,
	  polyfill: polyfill
	};


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Heading = __webpack_require__(44);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _BodyCopy = __webpack_require__(131);
	
	var _BodyCopy2 = _interopRequireDefault(_BodyCopy);
	
	var _CircleArrow = __webpack_require__(76);
	
	var _CircleArrow2 = _interopRequireDefault(_CircleArrow);
	
	var _LandingCardStyles = __webpack_require__(253);
	
	var _LandingCardStyles2 = _interopRequireDefault(_LandingCardStyles);
	
	var _urlTools = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandingCard = function LandingCard(_ref) {
	    var children = _ref.children,
	        headerText = _ref.headerText,
	        backgroundImages = _ref.backgroundImages,
	        animationColor = _ref.animationColor,
	        onClick = _ref.onClick,
	        linkUrl = _ref.linkUrl;
	
	
	    var styleProps = {
	        mobileView: {
	            backgroundImage: backgroundImages.mobileImage || ""
	        },
	        tabletView: {
	            backgroundImage: backgroundImages.tabletImage || ""
	        },
	        desktopView: {
	            backgroundImage: backgroundImages.desktopImage || ""
	        },
	        animationColor: animationColor
	    };
	
	    var circleArrowRef = null;
	
	    return _react2.default.createElement(
	        _LandingCardStyles2.default,
	        { styleProps: styleProps,
	            onMouseEnter: function onMouseEnter() {
	                circleArrowRef.playAnimation();
	            },
	            onMouseLeave: function onMouseLeave() {
	                circleArrowRef.stopAnimation();
	            },
	            className: 'landing-card' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: (0, _urlTools.getLinkWithQueryString)(linkUrl), title: headerText, onClick: onClick },
	            _react2.default.createElement(
	                'div',
	                { className: 'card-filter' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner-card-container' },
	                    _react2.default.createElement(
	                        _Heading2.default,
	                        {
	                            headingColor: _colors2.default.wsWhite,
	                            headingSize: 'xlarge',
	                            headingTag: 'h1' },
	                        headerText
	                    ),
	                    _react2.default.createElement(
	                        _BodyCopy2.default,
	                        {
	                            paragraphType: 'medium' },
	                        children
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'view-desktop' },
	                        _react2.default.createElement(_CircleArrow2.default, { ref: function ref(circleArrow) {
	                                return circleArrowRef = circleArrow;
	                            }, circleColor: _colors2.default.wsWhite, arrowColor: _colors2.default.wsWhite, circleAnimationColor: animationColor, backgroundColor: 'rgba(0, 0, 0, 0)', circleDiameter: '61' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'view-mobile view-tablet' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.wsWhite, arrowColor: _colors2.default.wsWhite, backgroundColor: 'rgba(0, 0, 0, 0)', circleDiameter: '42' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = LandingCard;
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    color: ', ';\n    cursor: pointer;\n    position: relative;\n\n    a, a:hover, a:visited {\n       color:  ', ';\n       text-decoration: none;\n    }\n    h1 { \n        display: inline-block;\n    }\n\n    .body-copy-component {\n        display: block;\n        margin: 0 auto;\n    }\n\n    .card-line {\n        display: block;\n    }\n    \n    .card-filter {\n        background-color: rgba(70, 70, 80, .21);\n        height: 100%;\n    }\n\n    .inner-card-container {\n        display: block;\n        margin: auto;\n        position: absolute;\n        text-align: center;\n        width: 100%;\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', ') {\n        background-image: url(\'', '\');\n        display: inline-block;\n        float: left;\n        height: 100%;\n        width: 33.3%;\n\n        &:nth-child(2) {\n            width: 33.4%\n        }\n\n        .body-copy-component {\n            display: block;\n            font-size: 23px;\n            letter-spacing: .55px;\n            text-shadow: 0 0 1px ', ';\n            width: 350px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            height: 68px;\n            margin-bottom: -4px;\n\n            h1 {\n                \n                font-size: 48px;\n                font-weight: 900;\n                letter-spacing: -1px;\n                position: relative;\n                z-index: ', ';\n            }\n\n            &:after {\n                background-color: ', ';\n                content: "none";\n                display: block;\n                font-size: 0;\n                height: 31px;\n                margin-bottom: -31px;\n                margin-left: -20px;\n                margin-right: -20px;\n                top: -30px;\n                -webkit-transition: width .5s;\n                transition: width .5s;\n                -webkit-transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);\n                transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);\n                position: relative;\n                width: 0;\n                z-index: ', ';\n            }\n        }\n        \n        .inner-card-container {\n            top: 40.1%;\n\n            @media screen and (max-height: 768px) {\n                bottom: 30%;\n                top: auto;\n            }\n\n            @media screen and (max-height: 600px) {\n                bottom: auto;\n                top: 30%;\n            }\n        }\n\n        &:nth-child(1){ \n            &:hover {\n                .heading-component:after {\n                    width: 204px;\n                }\n            }\n        }\n\n        &:nth-child(1) .inner-card-container {\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -5px;\n                padding-left: 4px;\n            }\n\n            .circle-arrow {\n                margin-top: 37px;\n                padding-left: 3px;\n            }\n        }\n\n        &:nth-child(2){ \n            &:hover {\n                .heading-component:after {\n                    width: 325px;\n                }\n            }\n        }\n    \n        &:nth-child(2) .inner-card-container {\n            margin-bottom: 5px;\n\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -2px;\n                padding-left: 12px;\n            }\n\n            .circle-arrow {\n                margin-top: 36px;\n                padding-left: 2px;\n            }\n        }\n\n        &:nth-child(3){ \n            &:hover {\n                .heading-component:after {\n                    width: 157px;\n                }\n            }\n        }\n    \n        &:nth-child(3) .inner-card-container {\n\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -2px;\n            }\n\n            .circle-arrow {\n                margin-top: 36px;\n                padding-left: 0px;\n            }\n        }\n    }\n    \n    /* - TABLET VIEW - */\n    @media screen and (', ') {\n        background-image: url(\'', '\');\n        height: 33.3%;\n        width: 100%;\n\n        &:first-child {\n            height: 33.4%;\n        }\n        \n        .body-copy-component {\n            font-size: 21px;\n            letter-spacing: .85px;\n            line-height: 1.24;\n            text-shadow: 0 0 1px ', ';\n            width: 305px;\n        }\n\n        .heading-component {\n            h1 {\n                font-size: 32px;\n                font-weight: 900;\n                letter-spacing: -.7px;\n            }\n\n        }\n\n        &:nth-child(1) .inner-card-container {\n            top: 28.5%;\n            \n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 10%;\n            }\n\n            .heading-component {\n                margin-bottom: 7px;\n            }\n\n            .body-copy-component {\n                line-height: 26px;\n            }\n\n            .circle-arrow {\n                margin-top: 12px;\n            }\n        }\n    \n        &:nth-child(2) .inner-card-container {\n            top: 32.5%;\n\n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 10%;\n            }\n\n            .heading-component {\n                margin-bottom: 3px;\n            }\n\n            .body-copy-component {\n                line-height: 26px;\n            }\n\n            .circle-arrow {\n                margin-top: 14px;\n            }\n        }\n    \n        &:nth-child(3) .inner-card-container {\n            top: 26.6%;\n\n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 12%;\n            }\n\n            .heading-component {\n                margin-bottom: 4px;\n            }\n\n            .body-copy-component {\n                letter-spacing: 1.25px\n                line-height: 28px;\n            }\n\n            .circle-arrow {\n                margin-top: 9px;\n            }\n        }\n\n         /* - MOBILE VIEW - */\n        @media screen and (', ') {\n            background-image: url(\'', '\');\n            height: 33.3%;\n            width: 100%;\n\n            &:nth-child(1n) {\n                &:hover {\n                    height: 33.3%;\n                    width: auto;\n                }\n            }\n            &:first-child {\n                height: 33.4%;\n\n                &:hover {\n                    height: 33.4%;\n                    width: auto;\n                }\n            }\n            .body-copy-component {\n                font-size: 18px;\n                letter-spacing: .7px;\n                line-height: 1.28;\n                width: 285px;\n            }\n\n            .heading-component {\n                h1 {\n                    font-size: 32px;\n                    font-weight: 900;\n                    letter-spacing: -.7px;\n                }\n            }\n\n            &:nth-child(1) .inner-card-container {\n                top: 18.5%;\n\n                .body-copy-component {\n                    line-height: 23px;\n                }\n\n                 .heading-component {\n                    margin-bottom: 1px;\n                }\n\n                .circle-arrow {\n                    margin-top: 6px;\n                    padding-left: 1px;\n                }\n            }\n            \n\n            &:nth-child(2) .inner-card-container {\n                top: 25%;\n\n                .body-copy-component {\n                    line-height: 22px;\n                }\n\n                 .heading-component {\n                    margin-bottom: -2px;\n                }\n\n                .circle-arrow {\n                    margin-top: 8px;\n                }\n            }\n\n            &:nth-child(3) .inner-card-container {\n                top: 11.5%;\n\n                .body-copy-component {\n                    letter-spacing: .7px;\n                    line-height: 23px;\n                }\n\n                 .heading-component {\n                    margin-bottom: 2px;\n                }\n\n                .circle-arrow {\n                    margin-top: 5px;\n                }\n            }\n        }\n   '], ['\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    color: ', ';\n    cursor: pointer;\n    position: relative;\n\n    a, a:hover, a:visited {\n       color:  ', ';\n       text-decoration: none;\n    }\n    h1 { \n        display: inline-block;\n    }\n\n    .body-copy-component {\n        display: block;\n        margin: 0 auto;\n    }\n\n    .card-line {\n        display: block;\n    }\n    \n    .card-filter {\n        background-color: rgba(70, 70, 80, .21);\n        height: 100%;\n    }\n\n    .inner-card-container {\n        display: block;\n        margin: auto;\n        position: absolute;\n        text-align: center;\n        width: 100%;\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', ') {\n        background-image: url(\'', '\');\n        display: inline-block;\n        float: left;\n        height: 100%;\n        width: 33.3%;\n\n        &:nth-child(2) {\n            width: 33.4%\n        }\n\n        .body-copy-component {\n            display: block;\n            font-size: 23px;\n            letter-spacing: .55px;\n            text-shadow: 0 0 1px ', ';\n            width: 350px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            height: 68px;\n            margin-bottom: -4px;\n\n            h1 {\n                \n                font-size: 48px;\n                font-weight: 900;\n                letter-spacing: -1px;\n                position: relative;\n                z-index: ', ';\n            }\n\n            &:after {\n                background-color: ', ';\n                content: "none";\n                display: block;\n                font-size: 0;\n                height: 31px;\n                margin-bottom: -31px;\n                margin-left: -20px;\n                margin-right: -20px;\n                top: -30px;\n                -webkit-transition: width .5s;\n                transition: width .5s;\n                -webkit-transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);\n                transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);\n                position: relative;\n                width: 0;\n                z-index: ', ';\n            }\n        }\n        \n        .inner-card-container {\n            top: 40.1%;\n\n            @media screen and (max-height: 768px) {\n                bottom: 30%;\n                top: auto;\n            }\n\n            @media screen and (max-height: 600px) {\n                bottom: auto;\n                top: 30%;\n            }\n        }\n\n        &:nth-child(1){ \n            &:hover {\n                .heading-component:after {\n                    width: 204px;\n                }\n            }\n        }\n\n        &:nth-child(1) .inner-card-container {\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -5px;\n                padding-left: 4px;\n            }\n\n            .circle-arrow {\n                margin-top: 37px;\n                padding-left: 3px;\n            }\n        }\n\n        &:nth-child(2){ \n            &:hover {\n                .heading-component:after {\n                    width: 325px;\n                }\n            }\n        }\n    \n        &:nth-child(2) .inner-card-container {\n            margin-bottom: 5px;\n\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -2px;\n                padding-left: 12px;\n            }\n\n            .circle-arrow {\n                margin-top: 36px;\n                padding-left: 2px;\n            }\n        }\n\n        &:nth-child(3){ \n            &:hover {\n                .heading-component:after {\n                    width: 157px;\n                }\n            }\n        }\n    \n        &:nth-child(3) .inner-card-container {\n\n            .body-copy-component {\n                line-height: 29px;\n                margin-top: -2px;\n            }\n\n            .circle-arrow {\n                margin-top: 36px;\n                padding-left: 0px;\n            }\n        }\n    }\n    \n    /* - TABLET VIEW - */\n    @media screen and (', ') {\n        background-image: url(\'', '\');\n        height: 33.3%;\n        width: 100%;\n\n        &:first-child {\n            height: 33.4%;\n        }\n        \n        .body-copy-component {\n            font-size: 21px;\n            letter-spacing: .85px;\n            line-height: 1.24;\n            text-shadow: 0 0 1px ', ';\n            width: 305px;\n        }\n\n        .heading-component {\n            h1 {\n                font-size: 32px;\n                font-weight: 900;\n                letter-spacing: -.7px;\n            }\n\n        }\n\n        &:nth-child(1) .inner-card-container {\n            top: 28.5%;\n            \n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 10%;\n            }\n\n            .heading-component {\n                margin-bottom: 7px;\n            }\n\n            .body-copy-component {\n                line-height: 26px;\n            }\n\n            .circle-arrow {\n                margin-top: 12px;\n            }\n        }\n    \n        &:nth-child(2) .inner-card-container {\n            top: 32.5%;\n\n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 10%;\n            }\n\n            .heading-component {\n                margin-bottom: 3px;\n            }\n\n            .body-copy-component {\n                line-height: 26px;\n            }\n\n            .circle-arrow {\n                margin-top: 14px;\n            }\n        }\n    \n        &:nth-child(3) .inner-card-container {\n            top: 26.6%;\n\n            @media screen and (max-height: 800px) {\n                top: auto;\n                bottom: 12%;\n            }\n\n            .heading-component {\n                margin-bottom: 4px;\n            }\n\n            .body-copy-component {\n                letter-spacing: 1.25px\n                line-height: 28px;\n            }\n\n            .circle-arrow {\n                margin-top: 9px;\n            }\n        }\n\n         /* - MOBILE VIEW - */\n        @media screen and (', ') {\n            background-image: url(\'', '\');\n            height: 33.3%;\n            width: 100%;\n\n            &:nth-child(1n) {\n                &:hover {\n                    height: 33.3%;\n                    width: auto;\n                }\n            }\n            &:first-child {\n                height: 33.4%;\n\n                &:hover {\n                    height: 33.4%;\n                    width: auto;\n                }\n            }\n            .body-copy-component {\n                font-size: 18px;\n                letter-spacing: .7px;\n                line-height: 1.28;\n                width: 285px;\n            }\n\n            .heading-component {\n                h1 {\n                    font-size: 32px;\n                    font-weight: 900;\n                    letter-spacing: -.7px;\n                }\n            }\n\n            &:nth-child(1) .inner-card-container {\n                top: 18.5%;\n\n                .body-copy-component {\n                    line-height: 23px;\n                }\n\n                 .heading-component {\n                    margin-bottom: 1px;\n                }\n\n                .circle-arrow {\n                    margin-top: 6px;\n                    padding-left: 1px;\n                }\n            }\n            \n\n            &:nth-child(2) .inner-card-container {\n                top: 25%;\n\n                .body-copy-component {\n                    line-height: 22px;\n                }\n\n                 .heading-component {\n                    margin-bottom: -2px;\n                }\n\n                .circle-arrow {\n                    margin-top: 8px;\n                }\n            }\n\n            &:nth-child(3) .inner-card-container {\n                top: 11.5%;\n\n                .body-copy-component {\n                    letter-spacing: .7px;\n                    line-height: 23px;\n                }\n\n                 .heading-component {\n                    margin-bottom: 2px;\n                }\n\n                .circle-arrow {\n                    margin-top: 5px;\n                }\n            }\n        }\n   ']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LandingCardContainer = _styledComponents2.default.div(_templateObject, _colors2.default.wsWhite, _colors2.default.wsWhite, _LandingPageStyles2.default.viewBreakpoints.desktop, function (props) {
	    return props.styleProps.desktopView.backgroundImage;
	}, _colors2.default.wsWhite, _LandingPageStyles2.default.zIndices.headerText, function (props) {
	    return props.styleProps.animationColor;
	}, _LandingPageStyles2.default.zIndices.headerBackground, _LandingPageStyles2.default.viewBreakpoints.tablet, function (props) {
	    return props.styleProps.tabletView.backgroundImage;
	}, _colors2.default.wsWhite, _LandingPageStyles2.default.viewBreakpoints.mobile, function (props) {
	    return props.styleProps.mobileView.backgroundImage;
	});
	
	exports.default = LandingCardContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/affordability-bg.50723db9.jpg";

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quality-bg.6c8337c1.jpg";

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/style-bg.d40f4353.jpg";

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-affordability-bg.649d6edc.jpg";

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-quality-bg.a75f4387.jpg";

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mobile-style-bg.cfbd4e4f.jpg";

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tablet-affordability-bg.649d6edc.jpg";

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tablet-quality-bg.a75f4387.jpg";

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tablet-style-bg.cfbd4e4f.jpg";

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  html {\n      /* - DESKTOP VIEW - */\n      @media screen and (', '){\n        min-height: 600px;\n      }\n      \n      /* - TABLET VIEW - */\n      @media screen and (max-width: 1024px){\n        min-height: 768px;\n      }\n\n      /* - MOBILE VIEW - */\n      @media screen and (max-width: 425px){\n        min-height: 640px;\n      }\n  }\n'], ['\n  html {\n      /* - DESKTOP VIEW - */\n      @media screen and (', '){\n        min-height: 600px;\n      }\n      \n      /* - TABLET VIEW - */\n      @media screen and (max-width: 1024px){\n        min-height: 768px;\n      }\n\n      /* - MOBILE VIEW - */\n      @media screen and (max-width: 425px){\n        min-height: 640px;\n      }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n\n  .cards-container {\n    height: 100%;\n  }\n  .copyright-sup {\n    font-size: 10px;\n    vertical-align: super;\n  }\n\n  &.main-content {\n    display: block;\n  }\n  \n'], ['\n  height: 100%;\n\n  .cards-container {\n    height: 100%;\n  }\n  .copyright-sup {\n    font-size: 10px;\n    vertical-align: super;\n  }\n\n  &.main-content {\n    display: block;\n  }\n  \n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _utils = __webpack_require__(45);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(94);
	
	var _LandingCard = __webpack_require__(252);
	
	var _LandingCard2 = _interopRequireDefault(_LandingCard);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	var _LandingFooter = __webpack_require__(53);
	
	var _LandingFooter2 = _interopRequireDefault(_LandingFooter);
	
	var _ScriptTags = __webpack_require__(28);
	
	var _ScriptTags2 = _interopRequireDefault(_ScriptTags);
	
	var _Analytics = __webpack_require__(18);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	var _ImageSets = __webpack_require__(77);
	
	var _ImageSets2 = _interopRequireDefault(_ImageSets);
	
	var _mobileQualityBg = __webpack_require__(593);
	
	var _mobileQualityBg2 = _interopRequireDefault(_mobileQualityBg);
	
	var _mobileAffordabilityBg = __webpack_require__(592);
	
	var _mobileAffordabilityBg2 = _interopRequireDefault(_mobileAffordabilityBg);
	
	var _mobileStyleBg = __webpack_require__(594);
	
	var _mobileStyleBg2 = _interopRequireDefault(_mobileStyleBg);
	
	var _tabletQualityBg = __webpack_require__(603);
	
	var _tabletQualityBg2 = _interopRequireDefault(_tabletQualityBg);
	
	var _tabletAffordabilityBg = __webpack_require__(602);
	
	var _tabletAffordabilityBg2 = _interopRequireDefault(_tabletAffordabilityBg);
	
	var _tabletStyleBg = __webpack_require__(604);
	
	var _tabletStyleBg2 = _interopRequireDefault(_tabletStyleBg);
	
	var _qualityBg = __webpack_require__(586);
	
	var _qualityBg2 = _interopRequireDefault(_qualityBg);
	
	var _affordabilityBg = __webpack_require__(585);
	
	var _affordabilityBg2 = _interopRequireDefault(_affordabilityBg);
	
	var _styleBg = __webpack_require__(587);
	
	var _styleBg2 = _interopRequireDefault(_styleBg);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _LandingPageStyles2.default.viewBreakpoints.desktop);
	
	__webpack_require__(385).polyfill();
	
	var LandingPageContainer = _styledComponents2.default.div(_templateObject2);
	
	var cardBackgroundImages = [new _ImageSets2.default(_mobileQualityBg2.default, _tabletQualityBg2.default, _qualityBg2.default), new _ImageSets2.default(_mobileAffordabilityBg2.default, _tabletAffordabilityBg2.default, _affordabilityBg2.default), new _ImageSets2.default(_mobileStyleBg2.default, _tabletStyleBg2.default, _styleBg2.default)];
	
	var IndexPage = function IndexPage(props) {
	
	  // save any utm params to local session cache
	  if (props.location && props.location.search) {
	    (0, _utils.saveUTMSessionParams)(props.location.search);
	  }
	
	  return _react2.default.createElement(
	    LandingPageContainer,
	    { className: 'main-content' },
	    _react2.default.createElement(_LandingHeader2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'cards-container' },
	      _react2.default.createElement(
	        _LandingCard2.default,
	        {
	          backgroundImages: cardBackgroundImages[0],
	          linkUrl: '/quality',
	          headerText: 'Quality',
	          animationColor: _colors2.default.primaryClaytonBlue,
	          onClick: function onClick() {
	            (0, _Analytics.send)('HIM2018', 'Button', 'Main LP - Quality');
	          } },
	        _react2.default.createElement(
	          'span',
	          { className: 'view-mobile view-tablet' },
	          'Our homes are built to stand up to a lifetime of memories.'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'view-desktop' },
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'Learn why Clayton Built',
	            _react2.default.createElement(
	              'span',
	              { className: 'copyright-sup' },
	              '\xA9'
	            ),
	            ' means'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'quality you can trust.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LandingCard2.default,
	        {
	          backgroundImages: cardBackgroundImages[1],
	          linkUrl: '/affordability',
	          headerText: 'Affordability',
	          animationColor: _colors2.default.primaryClaytonGreen,
	          onClick: function onClick() {
	            (0, _Analytics.send)('HIM2018', 'Button', 'Main LP - Affordability');
	          } },
	        _react2.default.createElement(
	          'span',
	          { className: 'view-mobile view-tablet' },
	          'Get the home you want at a price you can afford.'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'view-desktop' },
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'See how we keep costs down for'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'affordable homeownership.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _LandingCard2.default,
	        {
	          backgroundImages: cardBackgroundImages[2],
	          linkUrl: '/style',
	          headerText: 'Style',
	          animationColor: _colors2.default.secondaryKiddiePool,
	          onClick: function onClick() {
	            (0, _Analytics.send)('HIM2018', 'Button', 'Main LP - Style');
	          } },
	        _react2.default.createElement(
	          'span',
	          { className: 'view-mobile view-tablet' },
	          'Get the style you want at a price you\'ll love.'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'view-desktop' },
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'Get the style you want at a price'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'card-line' },
	            'you\'ll love.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_LandingFooter2.default, null),
	    _react2.default.createElement(_ScriptTags2.default, null),
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        meta: [{ 'name': 'viewport', 'content': 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }, { 'name': 'referrer', 'content': 'always' }, { 'charset': 'UTF-8' }, { 'http-equiv': 'X-UA-Compatible', 'content': 'IE=edge' }],
	        onChangeClientState: _Analytics.onHelmetChangeClientState,
	        script: [{
	          type: 'text/javascript',
	          innerHTML: '\n                    if (typeof fbq !== \'undefined\'){\n                        fbq(\'track\', \'PageView\');\n                    } else {\n                      console.error(\'fbq not loaded\');\n                    }\n                    if (typeof gtag !== \'undefined\'){\n                        gtag(\'event\', \'page_view\', {\'send_to\': \'AW-1040796449\',\'dynx_itemid\': \'HIM2018\',\'dynx_pagetype\': \'landing-page\'});\n                        gtag(\'event\', \'conversion\', {\n                          \'allow_custom_scripts\': true,\n                          \'send_to\': \'DC-6346097/fall1003/fall10+standard\'\n                      });\n                    } else {\n                      console.error(\'gtag not loaded\');\n                    }\n                '
	        }]
	      },
	      _react2.default.createElement(
	        'title',
	        null,
	        'Have It Made | Clayton Homes'
	      )
	    ),
	    _react2.default.createElement('img', { src: 'http://conv-tm.everesttech.net/stats/1/conv?cpk=OQmjPowBJ13hBw5Q5ygg&cak=TU1toTr1MuUd0sWsxs4Z' }),
	    _react2.default.createElement('img', { src: 'https://rtd-tm.everesttech.net/upi/?sid=AUjRvIoCguSZPQwST3fX&cs=1' })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-3de2190f77f67823a9e1.js